import React from 'react';
import { ReservationRouteProps, VerifyReservationCodeComponent } from '@lib/common';

export const VerifyReservationCodePage: React.FC<ReservationRouteProps> = ({
  match,
  history,
  location,
}) => {
  const reservationId = match.params['reservationId'];
  const failed = new URLSearchParams(location.search).has('failed');

  return (
    <VerifyReservationCodeComponent
      reservationId={reservationId}
      failed={failed}
      onVerifyCode={code => history.push(`/reservations/${reservationId}/account?code=${code}`)}
    />
  );
};
